export type AccountModalMode = "signin" | "register";

export async function openAccountModal(
  mode: AccountModalMode,
  trigger: HTMLElement | null = null,
) {
  try {
    if (window.LeadholdOpenAccountModal) {
      await window.LeadholdOpenAccountModal(mode, trigger);
      return;
    }
    await window.LeadholdAccountModal?.open({mode, trigger});
  } catch (error) {
    console.error("Не удалось открыть форму аккаунта.", error);
  }
}
